import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';
import { colorCategory, getDollarFormat } from 'utils/helpers';
import { Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GenericTable from 'screens/components/advanced/GenericTable';
import SalesChart from './SalesChart';
import AverageNetChart from './AverageNetChart';
import NumberTransChart from './NumberTransChart';
import DataGrid from './DataGrid';

const Body = ({ productSales, endDate, beginDate, handleShowCategorySummary, showCategorySummary, handleShowPlots, showPlots, handleExpandProductInfo, expandProductInfo }) => {
    let categorySummaryColumns = [
        { key: "Category", label: "Category" },
    ]
    let { province: productProvince } = productSales || [];
    productProvince = productProvince ? [...new Set(productProvince.split(", "))] : []; // Split the result into array and remove duplicate values

    // Change to test with array not string
    if (productProvince.includes("BC") || productProvince.includes("British Columbia")) {
        categorySummaryColumns.push({ key: "PST", label: "PST" },
            { key: "GST", label: "GST" },
            { key: "PST_VAPE", label: "PST_VAPE" })
    } else if (productProvince.includes("AB") || productProvince.includes("Alberta")) {
        categorySummaryColumns.push({ key: "GST", label: "GST" })
    } else if (productProvince.includes("ON") || productProvince.includes("Ontario")) {
        categorySummaryColumns.push({ key: "HST", label: "HST" })
    }

    categorySummaryColumns.push(
        { key: "DiscountAmount", label: "Discount Amount" },
        { key: "DepositAmount", label: "Deposit Amount" },
        { key: "GrossSales", label: "Gross Sales" })

    return (
        <React.Fragment>
            {
                productSales.list && productSales.list.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    //If there's DATA
                    <div>
                        <div>
                            <div className="row m-0 list_header text-center">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY hh:mm')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY hh:mm')}</b> : moment().format('MMMM Do, YYYY hh:mm')}</p>
                                    : moment().format('MMMM D, YYYY hh:mm')}
                            </div>
                        </div>
                        {
                            productSales.summary &&
                            <div className="row m-0 mb-2">
                                <div className="col-lg-12 title_summary">
                                    <h3 className="m-0">SUMMARY</h3>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 text-center border-right">
                                    {productProvince.includes("BC") || productProvince.includes("British Columbia") ?
                                        <div className="row">
                                            <h4 className="m-0 font-weight-semibold">Taxes</h4>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                <h5 className="m-0 font-weight-semibold">PST</h5>
                                                <h4 className="m-0 purple-text size_1-4vmax ">{`$${(productSales.summary.totalPST).toFixed(2)}`}</h4>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                <h5 className="m-0 font-weight-semibold">GST</h5>
                                                <h4 className="m-0 purple-text size_1-4vmax ">{`$${(productSales.summary.totalGST).toFixed(2)}`}</h4>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                <h5 className="m-0 font-weight-semibold">PST_VAPE</h5>
                                                <h4 className="m-0 purple-text size_1-4vmax ">{`$${(productSales.summary.totalPST_Vape).toFixed(2)}`}</h4>
                                            </div>
                                        </div>
                                        : productProvince.includes("AB") || productProvince.includes("Alberta") ?
                                            <div>
                                                <h4 className="m-0 font-weight-semibold">GST</h4>
                                                <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalGST).toFixed(2)}`}</h3>
                                            </div>
                                            : productProvince.includes("ON") || productProvince.includes("Ontario") ?
                                                <div>
                                                    <h4 className="m-0 font-weight-semibold">HST</h4>
                                                    <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalHST).toFixed(2)}`}</h3>
                                                    <br />
                                                </div> : <div></div>
                                    }
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-center border-right">
                                    <h4 className="m-0 font-weight-semibold">Discount Amount</h4>
                                    <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalDiscount).toFixed(2)}`}</h3><br />
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6 text-center border-right">
                                    <h4 className="m-0 font-weight-semibold">Deposit Amount</h4>
                                    <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalDepositAmount).toFixed(2)}`}</h3><br />
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6 text-center border-right">
                                    <h4 className="m-0 font-weight-semibold">Gross Sales</h4>
                                    <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalGrossSales).toFixed(2)}`}</h3><br />
                                </div>

                            </div>
                        }
                        {productSales.categoryAll &&
                            <div className="row m-0 mb-2">
                                <Button
                                    label=""
                                    startIcon={<VisibilityIcon />}
                                    fullWidth={true}
                                    sx={{ color: "white", backgroundColor: "#9683E5" }}
                                    variant={"contained"}
                                    onClick={() => handleShowCategorySummary()}
                                >
                                    Show Summary By Category
                                </Button>
                                {showCategorySummary &&
                                    <div className="discount-report-table">
                                        <GenericTable
                                            className="table_center tableHeaderwhiteColorFont"
                                            stripedRows={true}
                                            columns={categorySummaryColumns}
                                            rows={productSales.summaryByCategory.map((item) => {
                                                return {
                                                    Category: item.categoryName,
                                                    PST: getDollarFormat(item.totalPST),
                                                    GST: getDollarFormat(item.totalGST),
                                                    PST_VAPE: getDollarFormat(item.totalPST_Vape),
                                                    HST: getDollarFormat(item.totalHST),
                                                    DiscountAmount: getDollarFormat(item.totalDiscount),
                                                    DepositAmount: getDollarFormat(item.totalDepositAmount),
                                                    GrossSales: getDollarFormat(item.totalGrossSales),
                                                    BranchName:item.branchName
                                                }
                                            })
                                            }
                                        />
                                    </div>
                                }
                            </div>
                        }
                        <div className="col-lg-12 mt-2 bg-light clearfix" >
                            <Button
                                label=""
                                startIcon={<VisibilityIcon />}
                                fullWidth={true}
                                sx={{ color: "white", backgroundColor: "#9683E5" }}
                                variant={"contained"}
                                onClick={() => handleShowPlots()}
                            >
                                Show Hourly Plots
                            </Button>
                            { showPlots ? 
                                <div>
                                    <SalesChart />
                                    <AverageNetChart />
                                    <NumberTransChart />
                                </div> : null
                            }
                        </div>
                        <br/>
                        {
                            productSales.list &&
                            <div className="col-lg-12 title_summary">
                                <h3 className="m-0">DETAILS</h3>
                            </div>
                        }
                        <Button
                            label=""
                            startIcon={<VisibilityIcon />}
                            fullWidth={false}
                            sx={{ color: "white", backgroundColor: "#9683E5" }}
                            variant={"contained"}
                            onClick={() => handleExpandProductInfo()}
                        >
                            {expandProductInfo ? "Collapse" : "Expand"} Product Info
                        </Button>
                        <DataGrid 
                            expandProductInfo={expandProductInfo}
                        />
                        
                    </div>
            }
        </React.Fragment>
    );
};

export default Body;